import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import identity from 'lodash/identity';
import ChoiceBoxSection from '../ChoiceBoxSection/index';
import ChoiceBoxWithControl from '../ChoiceBoxWithControl';
import ChoiceBox from '../ChoiceBox';
import withSelect from '../withSelect';

const ChoiceBoxSelect = ({
  OptionEstimator = false,
  value = undefined,
  renderer = null,
  optionRenderer = null,
  options,
  keyBy = identity,
  labelBy = identity,
  imageBy = identity,
  onChange = noop,
  disabled = false,
  nullable = false,
  hrefBy = noop,
  indexable = false,
  displayCheckbox = false,
  ...rest
}) => {
  const OptionRenderer = renderer || optionRenderer;

  const selectOptions = options.map((option) => {
    // common props
    const choiceBoxProps = {
      key: keyBy(option),
      selected: value === option,
      onClick: () => onChange(option),
      href: hrefBy(option),
      indexable,
    };

    if (OptionRenderer) {
      return (
        <ChoiceBox {...choiceBoxProps}>
          <OptionRenderer
            value={option}
            label={labelBy(option)}
            imageSrc={imageBy(option)}
            href={hrefBy(option)}
            indexable={indexable}
            selected={value === option}
          />
        </ChoiceBox>
      );
    }
    if (OptionEstimator) {
      return (
        <ChoiceBoxWithControl
          {...choiceBoxProps}
          label={labelBy(option)}
          imageSrc={imageBy(option)}
          displayCheckbox={displayCheckbox}
          OptionEstimator={OptionEstimator}
        />
      );
    }
    return (
      <ChoiceBox
        {...choiceBoxProps}
        label={labelBy(option)}
        imageSrc={imageBy(option)}
        displayCheckbox={displayCheckbox}
      />
    );
  });

  return (
    <ChoiceBoxSection {...rest}>
      {selectOptions}
    </ChoiceBoxSection>
  );
};

/* eslint-disable react/forbid-prop-types */
ChoiceBoxSelect.propTypes = {
  // select options (not configurator options)
  options: PropTypes.array.isRequired,
  value: PropTypes.any,
  // option => option.keyProp
  keyBy: PropTypes.func,
  // developer can supply either:
  // (a) a custom renderer (renderer or optionRenderer)
  // (b) labelBy and imageBy selectors
  labelBy: PropTypes.func,
  imageBy: PropTypes.func,
  renderer: PropTypes.func,
  optionRenderer: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool, // TODO implement UI for ChoiceBoxSelect.disabled
  nullable: PropTypes.bool,
  hrefBy: PropTypes.func,
  indexable: PropTypes.bool,
  displayCheckbox: PropTypes.bool,
  OptionEstimator: PropTypes.bool,
};

export default withSelect(ChoiceBoxSelect);
